import { SurveyEditPageStep } from "@/pages/talent/surveys/edit/survey-edit.ts";
import { ApiSurveyEdit, ApiSurveyStatus } from "@/types/survey.types.ts";
import { LinkTo, Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export interface SurveyEditSidebarProps {
  step: SurveyEditPageStep;
  survey?: ApiSurveyEdit;
}

export const SurveyEditSidebar = ({ step, survey }: SurveyEditSidebarProps) => {
  const { t } = useTranslation();

  const menuItems = [
    {
      step: SurveyEditPageStep.details,
      title: t("common:details"),
    },
    {
      step: SurveyEditPageStep.questions,
      title: t("common:questionnaire"),
    },
    {
      step: SurveyEditPageStep.launch,
      title: t("common:launch_plan"),
    },
    {
      step: SurveyEditPageStep.notifications,
      title: t("common:notifications"),
    },
  ];
  const currentStepIndex = menuItems.findIndex((item) => item.step === step);

  return (
    <Stack className={"px-6"} gap={"md"}>
      {menuItems.map((item, itemIndex) => {
        const className = step === item.step ? "text-default" : "text-secondary";
        const isLinkAvailable =
          survey && (survey.status !== ApiSurveyStatus.draft || itemIndex < currentStepIndex);

        if (!isLinkAvailable) {
          return (
            <Text key={item.step} className={className}>
              {item.title}
            </Text>
          );
        }

        return (
          <LinkTo
            key={item.step}
            to={`/surveys/${survey.id}/setup/${item.step}`}
            variant={"plain"}
            className={className}
          >
            <Text>{item.title}</Text>
          </LinkTo>
        );
      })}
    </Stack>
  );
};
